import React from 'react';
import prettyBytes from 'pretty-bytes';
import { observer } from 'mobx-react-lite';

import { Progress } from '../../../components/progress/Progress';
import { getStorageRegionDisplayName } from '../services/storage.service';

import { Space } from '../../../app/entities';

import styles from './storage-progress.module.scss';
type StorageProgressProps = {
  space: Space;
};

export const StorageProgress: React.FC<StorageProgressProps> = observer(({ space }) => {
  const percentage = (space.storage.current / space.storage.limit) * 100;
  const region = getStorageRegionDisplayName(space.storage.region);
  const total = prettyBytes(space.storage.current || 0);
  const limit = prettyBytes(space.storage.limit);

  return (
    <div className={styles['panel-container']}>
      <PanelHeader>
        <label>Storage used</label>
        <label>Storage size</label>
      </PanelHeader>

      <div className={styles['amount-space-container']}>
        <Amount>{total}</Amount>
        <Amount disable>{limit}</Amount>
      </div>

      <Progress percentage={percentage} />

      <footer className={styles['panel-footer']}>
        <label className={styles['used-amount']}>{percentage.toFixed(2)}%</label>
        <label className={styles['location-container']}>
          <span>Storage region</span> • <span>{region}</span>
        </label>
      </footer>
    </div>
  );
});

/** Exported: storage-billing-section renders these two directly. */
export const PanelHeader = ({ className, ...props }: React.ComponentPropsWithoutRef<'header'>) => (
  <header
    className={className ? `${styles['panel-header']} ${className}` : styles['panel-header']}
    {...props}
  />
);

export const Amount = ({
  disable,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'p'> & { disable?: boolean }) => (
  <p
    className={className ? `${styles['amount']} ${className}` : styles['amount']}
    data-disable={!!disable}
    {...props}
  />
);
